<template>
  <div class="wrap">
    <div class="title-box">
      <span class="title">合同信息</span>
    </div>
    <div class="tw-px-[16px]">
      <el-table
        class="custom-table"
        :data="tableData"
        :border="true"
        style="width: 100%"
        header-cell-class-name="custom-header"
      >
        <el-table-column show-overflow-tooltip prop="contractName" label="合同名称" />
        <el-table-column show-overflow-tooltip prop="contractCode" label="合同编号" />
        <el-table-column show-overflow-tooltip prop="status" label="合同状态">
          <template #default="{ row }">
            <span>{{ contactList.find(v => v.value === row.status)?.label }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="sendTime" label="发起时间" />
        <el-table-column show-overflow-tooltip prop="completeTime" label="合同完成时间" />
        <!-- 分销不展示操作栏 -->
        <el-table-column fixed="right" label="操作" width="160">
          <template #default="{ row }">
            <el-button
              :loading="previewLoadingId === row.id"
              link
              type="primary"
              @click="handleClick(row)"
            >
              预览
            </el-button>
            <el-button
              v-if="row.status === 20 || row.status === 80"
              :loading="downloadLoadingId === row.id"
              link
              type="primary"
              @click="handleDown(row)"
            >
              下载
            </el-button>
            <el-button v-if="row.status === 80" link type="primary" @click="handleView(row)">
              查看作废协议
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { contactList } from '@/views/erp/enums'
import { getContact } from '@/apis/erp/income'
import { afterSaveView, preSaveView } from '@/apis/erp/contractManage'
import { useGlobalContract } from '@/stores/modules/globalContract'
import { downLoadContract } from '@/views/erp/base/contractManage/utils'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  comType: Number
})

const tableData = ref([])

onMounted(() => {
  if (props.id) {
    getContact({ businessCode: props.id }).then(res => {
      tableData.value = res
    })
  }
})

const previewLoadingId = ref('')
async function handleClick(row: Recordable) {
  try {
    previewLoadingId.value = row.id
    let api = afterSaveView
    if (row.status === 60 || row.status === 70) {
      api = preSaveView
    }
    const res = await api({ id: row.id })
    window.open(res)
  } finally {
    previewLoadingId.value = ''
  }
}
const downloadLoadingId = ref('')
async function handleDown(row: Recordable) {
  try {
    downloadLoadingId.value = row.id
    await downLoadContract(row.id, 'sign')
  } finally {
    downloadLoadingId.value = ''
  }
}

const globalContract = useGlobalContract()
function handleView(row: Recordable) {
  globalContract.init({
    contractId: row.id,
    type: 'remove'
  })
}
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}

:deep(.custom-header) {
  padding: 0;
  height: 40px;
  line-height: 40px;
  background: #f4f4f5 !important;
  .cell {
    line-height: 40px;
    font-size: 14px;
    color: #666666;
    font-weight: 700;
  }
}
</style>
